import i18n from "../../../lib/i18n";
import AddBannersUi from "../../../ui/bannersUi/addBannersUi";

export default function AddBanners () {

    const t = i18n.t.bind(i18n); 

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("add_page_title.banner")}</h1>
                <AddBannersUi />
            </div>
        </div>
    );
};